<div
  class="order-history--container clickable font-5"
  role="link"
  (click)="navigateToOrder()"
>
  <div class="order-history--date">
    <label>Date</label>
    <span>{{ order.order_date | dateFormat: 'MM/DD' }}</span>
  </div>
  <div class="order-history--id">
    <label>Order #</label>
    <span>{{ order.id }}</span>
  </div>
  <div class="order-history--state">
    <label>Status</label>
    <span class="fw-bold" [ngClass]="statusColorClass">{{ status }}</span>
  </div>
  <div class="order-history--total">
    <label>Total</label>
    <span class="price fw-normal">{{ order.order_total | currency }}</span>
  </div>
</div>
